<!-- 
	This is the Orders List page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->
 <template>
	<div>
		<!-- Orders List card -->
		<a-card :bordered="false" class="header-solid mb-24" :bodyStyle="{padding: 0, paddingTop: '16px'}">
            <a-table class="mt-20" size="small"
				:columns="columns"
				:data-source="ordersSource"
				:pagination="{pageSize: pageSize}"
				rowKey="pickupNumber"
			>   
                <template slot="pickupNumber" slot-scope="pickupNumber">#{{ pickupNumber }}</template>

				
				<template slot="pickupTime" slot-scope="pickupTime">
					<a-tag v-if="!isOverTime(pickupTime)" color="green">
						<a-icon type="clock-circle" /> {{ formatTime(pickupTime) }}
					</a-tag>
					<a-tag v-else color="red">
						<a-icon type="warning" /> {{ formatTime(pickupTime) }}
					</a-tag>
					
				</template>


				<template slot="status" slot-scope="status">
    				<a-tag v-if="status == 0" color="green">
						Confirmed
					</a-tag>
					<a-tag v-if="status == 1" color="red">
						Cancelled
					</a-tag>
					<a-tag v-if="status == 2" color="red">
						Rejected
					</a-tag>
				</template>

				<template slot="isPaid" slot-scope="isPaid">
					<a-tag v-if="isPaid == false" color="red">
						Not Paid
					</a-tag>
					<a-tag v-if="isPaid == true" color="green">
						Paid
					</a-tag>
				</template>

				<template slot="actions" slot-scope="record">
					<a-button-group>

						<a-button shape="circle" icon="eye" size="small" @click="handleBtnView(record)"/>

						<a-button shape="circle" icon="select" size="small" @click="handleBtnAction(record)"/>

					</a-button-group>
				</template>

            </a-table>
			
		</a-card>
		<!-- / Orders List card -->
		<order-detail-modal ref="orderModal" :order="currentOrder"/>
		<order-action-modal ref="orderActionModal" 
							@setReadyEventClicked="handleBtnUpdateOrderToReadyState(false)"
							@setDeliveredEventClicked="handleBtnUpdateOrderToReadyState(true)"
							@setPrintOrderEventClicked="handlePrintOrderEvent"
							@changePickupTimeEventClicked="handleChangePickupTimeEvent"
							@changePickupDateEventClicked="handleChangePickupDateEvent"
							@cancelOrderEventClicked="handleCancelOrderEvent"
							@setChangedPriorityOrASAPClicked="handleSetChangedPriorityOrASAPEvent"
							@viewOrderEventClicked="handleViewOrderEventClicked"
		/>
		<pickup-time-edit-modal ref="pickupTimeEditModal"/>
		<ready-delivery-confirm-modal ref="readyDeliveryConfirmModalRef"
			@setReadyEventClicked="handleBtnUpdateOrderToReadyState(false)"
			@setDeliveredEventClicked="handleBtnUpdateOrderToReadyState(true)"
		/>
		<cancel-order-modal ref="cancelOrderModal" />
		<priority-or-asap-edit-modal ref="priorityOrAsapEditModal" />
		<pickup-date-edit-modal ref="pickupDateEditModal"/>
		<scanning-message-modal ref="scanningMessageModalRef"
            @viewOrderEvent="handleViewOrderEvent"
        />
	</div>

</template>

<script>
import OrderDetailModal from '../../../components/modals/OrderDetailModal.vue'
import OrderActionModal from './OrderActionModal.vue'
import PickupTimeEditModal from './PickupTimeEditModal.vue'
import CancelOrderModal from './CancelOrderModal.vue'
import PriorityOrAsapEditModal from './PriorityOrASAPEditModal.vue'
import PickupDateEditModal from './PickupDateEditModal.vue'
import ScanningMessageModal from '../../../components/modals/ScanningMessageModal.vue'
import ReadyDeliveryConfirmModal from './ReadyDeliveryConfirmModal.vue'
import PhoneIcon from '../../../components/icons/PhoneIcon.vue'
import moment from 'moment';
	const columns = [
		{
			title : '#',
			dataIndex : 'pickupNumber',
			key : 'pickupNumber',
			fixed: 'left',
			scopedSlots : { customRender: 'pickupNumber'} 
		},
		{
			title : 'CUSTOMER',
			dataIndex: 'customerName'
		},
		{
			title : 'PICKUP TIME',
			dataIndex : 'pickupTime',
			scopedSlots : { customRender: 'pickupTime'} 
		},
		{
			title : 'AMOUNT',
			dataIndex : 'amount'
		},
		{
			title : 'STATUS',
			dataIndex : 'status',
			scopedSlots : { customRender: 'status'} 
		}, 

		{
			title : 'IS PAID',
			dataIndex : 'isPaid',
			scopedSlots : { customRender: 'isPaid'} 
		},
		{
			title : 'ACTIONS',
			scopedSlots : { customRender: 'actions'},
			fixed: 'right'
			
		}
	];
	
	export default {
        props : {
            ordersSource : {type: Array}
        },
		components : {
			OrderDetailModal,
			OrderActionModal,
			PickupTimeEditModal,
			CancelOrderModal,
			PriorityOrAsapEditModal,
			PickupDateEditModal,
			ScanningMessageModal,
			ReadyDeliveryConfirmModal,
			PhoneIcon
		},
		data() {
			return {
				columns,
				pageSize: 5,
				currentOrder : null,
				total : 0
			}
		},
		
		
		watch : {
			
		},

		methods: {
			async sleep(miliSeconds) {
            	return new Promise(r => setTimeout(r, miliSeconds));
        	},

			isOverTime(pickupTime) {

				let now = moment();
				let time =  moment(pickupTime, 'HH:mm:ss');
				let minutesFromPickupTime = time.minutes() + (time.hours() * 60)
          		let minutesFromNow = now.minutes() + (now.hours() * 60)
				
				return (minutesFromNow - minutesFromPickupTime >= 0)
			},

			isLate(pickupTime, endTime) {
				let time1 =  moment(pickupTime, 'HH:mm:ss');
				let time2 = moment(endTime, 'HH:mm:ss');
				let minutesFromPickupTime = time1.minutes() + (time1.hours() * 60);
				let minutesFromEndTime = time2.minutes() + (time2.hours() * 60);
				return (minutesFromEndTime - minutesFromPickupTime >= 0);

			},

			async handleBarcodeReadingEvent(e) {
				console.log(e)
            	if (!this.isProcessing) {
                	this.isProcessing = true;
                	
                	this.$refs['scanningMessageModalRef'].showModalToWait();

                	this.currentOrder = this.$store.state.orderManager.orders.find(o => { return o.orderId === e});

                	await this.sleep(1000);
                	this.$refs['scanningMessageModalRef'].handleCancel();
					console.log(this.currentOrder)
                	if(this.currentOrder != null) {
						//conso
						this.$refs['readyDeliveryConfirmModalRef'].show(this.currentOrder);
                	}

                	else {
                    	this.$warning({
                        	title : 'Cannot find the order: ' + e,
                        	content : 'Please check again!'
                    	});
                	}
                	this.isProcessing = false;
            	}
            
        	},
        	
			handleBtnView(record) {
				this.$refs['orderModal'].show(record);
			},

			handleViewOrderEventClicked() {
				if(this.currentOrder.orderId != null) {
					this.$refs['orderModal'].show(this.currentOrder);
				}
				
			},

			handleBtnAction(record) {
				console.log(record.orderId)
				if(record.orderId != null) {
					this.currentOrder = record;
					this.$refs['orderActionModal'].show(record);
					//this.$refs['readyDeliveryConfirmModalRef'].show(record);
				}
				
			},

			handleViewOrderEvent(record) {
				if(record.orderId != null) {
					this.currentOrder = record;
					this.$refs['orderActionModal'].show(record);
				}
			},

			handleChangePickupTimeEvent() {
			//console.log('change pickup time: ' + record)
				if(this.currentOrder.orderId != null) {
					this.$refs['pickupTimeEditModal'].show(this.currentOrder);
				}
				
			},

			handleChangePickupDateEvent() {
			
				if(this.currentOrder.orderId != null) {
					this.$refs['pickupDateEditModal'].show(this.currentOrder);
				}
				
			},

			handleCancelOrderEvent() {
				if (this.currentOrder != null) {
					this.$refs['cancelOrderModal'].show(this.currentOrder);
				}
				
			},

			handleSetChangedPriorityOrASAPEvent() {
				if (this.currentOrder != null) {
					if(!this.currentOrder.asap) {
						this.$refs['priorityOrAsapEditModal'].show(this.currentOrder);
					}
					else {
						this.$notification['error']({
							message : 'OBS!',
							description : 'The order is set to be ASAP!!!'
						})
					}
					
				}
				
			},

			handleChangePickupDayEvent(record) {
				if (this.currentOrder != null) {
					this.$refs['changePickupDayModal'].show(record);
				}
				
			},

			formatTime(time) {
				let formattedTime = moment(time, 'HH:mm:ss')
				return formattedTime.format('HH:mm');
			},

			
			async setOrderToReadyOrDelivered(isDelivered) {

				let payload = {
					orderId : this.currentOrder.orderId,
					isDelivered : isDelivered
				} 
						
				this.$message.loading('Updating data...', 0);

				let isSuccess = await this.$store.dispatch('orderManager/updateOrderToReadyOrderAction', payload);
						
				if(!isSuccess) {
					this.$message.error('Something was wrong, please try again!', 5);
				}
				else {
					this.$message.success('Update successfully!', 3);
				}

				this.$message.destroy();
			},

			async handleBtnUpdateOrderToReadyState(isDelivered) {
				
				if(this.currentOrder.orderId != null) {
					
					await this.setOrderToReadyOrDelivered(isDelivered);
					
				}
			},

			async handlePrintOrderEvent() {
				console.log('Print order command is sent');
				//console.log(e)
				if(this.currentOrder != null) {
					
					this.$message.loading('Sending data to server...', 0);
           	 		let isSuccess = await this.$store.dispatch('orderManager/printOrderFromClientAction', this.currentOrder);
					if(!isSuccess) {
						this.$message.error('Something was wrong, please try again!', 5);
					}
					else {
						this.$message.success('The order will be printed after 30s!', 15);
					}
						this.$message.destroy();
				}
				
			}
        },

		created() {
			this.$barcodeScanner.init(this.handleBarcodeReadingEvent);
        	this.$barcodeScanner.setSensitivity(2000);
		},
		destroyed() {
			this.$barcodeScanner.destroy();
		}
	}

</script>

<style lang="scss" scoped>
	.table-avatar-info {
		display: flex;
		align-items: center;
	}
	.table-avatar-info .ant-avatar {
		margin-right: 8px;
	}

	// Using vuejs "Deep Selectors"
	.table-avatar-info::v-deep .ant-avatar-string {
		font-size: 12px;
	}
	.btn-status::v-deep .anticon {
		line-height: 0;
	}
</style>